<template>
  <div class='customer-profile'>
      <avatar-upload  class="avatar" :file-url="fileUrl"  @changed='updateAvatarUrl'/>
    <div class="form">
      <edit-customer-profile-form class='profile-form' @changeFormValidation="changeFormValidation"/>
      <div class="actions d-flex">
        <v-btn color="primary" class='submit-form' :disabled="!valid" @click="submit">
          {{ $t('save') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EditCustomerProfileForm from '@/components/forms/EditCustomerProfileForm.vue';
import {LOAD_CUSTOMER_PROFILE_DETAILS, UPDATE_CUSTOMER_PROFILE} from '@/store/user/actionTypes';
import AvatarUpload from '@/components/common/AvatarUpload.vue';

export default {
  name: 'CustomerProfile',
  components: {
    AvatarUpload,
    EditCustomerProfileForm,
  },
  data() {
    return {
      valid: false,
    };
  },
  computed: {
    ...mapGetters([
      'customerProfileDetails',
    ]),
    fileUrl() {
      if (
        !this.customerProfileDetails?.avatarURL ||
        this.customerProfileDetails?.avatarURL?.startsWith('data')
      ) {
        return this.customerProfileDetails?.avatarURL;
      }
      return `${this.customerProfileDetails?.avatarURL}?${Date.now().toString()}` || null;
    },
  },
  methods: {
    updateAvatarUrl(file) {
      this.customerProfileDetails.avatarURL = file;
    },
    async submit() {
      const payload = { ...this.customerProfileDetails };
      if (!this.customerProfileDetails?.avatarURL?.startsWith('data')) {
        payload.avatarURL = null;
      }
      try {
        await this.$store.dispatch(UPDATE_CUSTOMER_PROFILE, payload);
      } catch (e) {
        this.$emit('showInvalidFormError', e);
        await this.$store.dispatch(LOAD_CUSTOMER_PROFILE_DETAILS);
      }
    },
    changeFormValidation(valid) {
      this.valid = valid;
    },
  },
};
</script>

<style lang='scss' scoped>
@import '../../assets/styles/variables';
.customer-profile {
  display: flex;
  flex: 1;

  padding-top: 40px;
  padding-bottom: 40px;
  margin-left: 10%;

  padding-right: 152px;

  border-radius: 4px;
  background-color: var(--bg-primary);
}

.form {
  flex: 1;
  display: flex;
  flex-direction: column;
  .profile-form {
    flex: 1;
    max-width: 80%;
  }
}

.avatar {
  flex: 0.35;
  margin-right: 7%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

  fieldset {
    legend {
      width: 0 !important;
      padding: 0 !important;
    }
  }
</style>

<style lang="scss">
@import '../../assets/styles/sizing';

// Unscoped styles to override Vuetify legend width for all input types on profile page
.customer-profile {
  .v-text-field--outlined fieldset legend,
  .v-autocomplete.v-text-field--outlined fieldset legend,
  .vue-tel-input-vuetify.v-text-field--outlined fieldset legend {
    width: 0 !important;
    padding: 0 !important;
  }

  // Dark mode: ensure labels and input text are readable
  .v-label {
    color: var(--text-secondary) !important;
    background: transparent !important;
  }
  .v-text-field input,
  .v-select__selection,
  .v-autocomplete input {
    color: var(--text-primary) !important;
  }

  // Force all input slot backgrounds to transparent
  .v-input__slot {
    background-color: transparent !important;
  }

  // vue-tel-input-vuetify country code selector (has inline background-color prop)
  .vue-tel-input-vuetify .country-code .v-input__slot {
    background-color: transparent !important;
  }

  // Fix input sizing and spacing
  .v-text-field--outlined,
  .v-autocomplete.v-text-field--outlined,
  .vue-tel-input-vuetify.v-text-field--outlined {
    overflow: visible !important;
    .v-input__control {
      overflow: visible !important;
    }
    .v-input__slot {
      overflow: visible !important;
      background-color: transparent !important;
    }
    fieldset {
      border-color: var(--border-primary);
    }
    &.v-input--dense {
      .v-input__control > .v-input__slot {
        min-height: rem(40) !important;
      }
      .v-label {
        top: rem(10) !important;
        font-size: rem(12) !important;
        background: transparent !important;
      }
      .v-label--active {
        transform: translateY(rem(-26)) scale(0.85) !important;
        background: transparent !important;
      }
    }
  }

  // vue-tel-input-vuetify internal v-select (country) — override inline style
  .vue-tel-input-vuetify {
    .country-code {
      .v-select {
        .v-input__slot {
          background-color: transparent !important;
        }
      }
    }
    // The phone number text field inside vue-tel-input-vuetify
    > .v-text-field .v-input__slot {
      background-color: transparent !important;
    }
  }
}
</style>
